import { mapActions, mapGetters } from 'vuex'
export default {
  methods: {
    ...mapActions('cart', ['checkoutCart']),
    async onCheckoutHandler () {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Are you sure? All the forms in your cart will be submitted',
        {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'success',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      if (!ok) return
      await this.checkoutCart()
      this.$router.push({ name: 'my-orders' })
      this.$root.$bvToast.toast(`Items where submitted.`, {
        title: 'Cart Checkout',
        solid: true,
        variant: 'success',
        autoHideDelay: 500,
        appendToast: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })
    }
  }
}
